(function() {
  const GLOBAL_DOMAIN = 'aemery.com';
  const US_DOMAIN = 'us.aemery.com';
  const COOKIE_NAME = 'store_choice';
  const COOKIE_DAYS = 7;

  function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/';
  }

  function isOnUSSite() {
    const h = window.location.hostname;
    return h === US_DOMAIN || h === 'www.' + US_DOMAIN;
  }

  function isProductionDomain() {
    return window.location.hostname.endsWith('aemery.com');
  }

  function getStoreType() {
    if (isProductionDomain()) {
      return isOnUSSite() ? 'us' : 'global';
    }
    return (typeof window.AEMERY_STORE_TYPE === 'string') ? window.AEMERY_STORE_TYPE : 'global';
  }

  const button = document.querySelector('.store-selector__button');
  const dropdown = document.querySelector('.store-selector__dropdown');
  if (!button || !dropdown) return;

  // Toggle dropdown
  button.addEventListener('click', function() {
    const expanded = this.getAttribute('aria-expanded') === 'true';
    this.setAttribute('aria-expanded', String(!expanded));
    dropdown.hidden = expanded;
  });

  // Close on click outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.store-selector')) {
      button.setAttribute('aria-expanded', 'false');
      dropdown.hidden = true;
    }
  });

  // Close on Escape
  document.addEventListener('keyup', function(e) {
    if (e.key === 'Escape') {
      button.setAttribute('aria-expanded', 'false');
      dropdown.hidden = true;
    }
  });

  // Handle item click
  dropdown.querySelectorAll('a[data-store]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();

      const store = this.dataset.store;
      const country = this.dataset.country;

      // Set cookie so geolocation.js respects the choice
      setCookie(COOKIE_NAME, country, COOKIE_DAYS);

      var storeType = getStoreType();
      if (store === 'us') {
        if (storeType === 'us') {
          dropdown.hidden = true;
          button.setAttribute('aria-expanded', 'false');
        } else {
          var path = window.location.pathname;
          var sep = path.indexOf('?') >= 0 ? '&' : '?';
          window.location.href = 'https://' + US_DOMAIN +
            path + sep + 'store_choice=' + country;
        }
      } else {
        if (storeType === 'us') {
          window.location.href = 'https://' + GLOBAL_DOMAIN +
            window.location.pathname + '?store_choice=' + country;
        } else if (storeType === 'global') {
          const form = document.querySelector('#localization_form') || document.querySelector('.store-selector__hidden-form');
          const input = form ? form.querySelector('input[name="country_code"]') : null;
          if (form && input) {
            input.value = country;
            form.submit();
          }
        }
      }
    });
  });
})();
